import { render } from "./EditTransaction.vue?vue&type=template&id=ef74b2d6&ts=true"
import script from "./EditTransaction.vue?vue&type=script&lang=ts"
export * from "./EditTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__